var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionInfo04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#F5F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1218 20.4792C23.7313 20.0886 23.0981 20.0886 22.7076 20.4792L22.0005 21.1863C21.2194 21.9673 19.9531 21.9673 19.172 21.1863C18.391 20.4052 18.391 19.1389 19.172 18.3578L24.8027 12.7257C26.9066 12.2497 29.2013 12.8308 30.8393 14.4688C33.2587 16.8881 33.3721 20.7402 31.1797 23.2939L29.0715 25.4289L24.1218 20.4792ZM13.1616 14.4688C15.335 12.2954 18.6646 11.9828 21.1705 13.5312L17.7578 16.9436C16.1957 18.5057 16.1957 21.0384 17.7578 22.6005C19.2726 24.1152 21.7 24.1611 23.27 22.7382L23.4147 22.6005L27.6573 26.8431L23.4147 31.0858C22.6336 31.8668 21.3673 31.8668 20.5863 31.0858L13.1616 23.6611C10.6232 21.1227 10.6232 17.0072 13.1616 14.4688Z",
    fill: "url(#paint0_linear_1788_10330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1788_10330",
    x1: 9.58531,
    y1: 5.07215,
    x2: 58.2692,
    y2: 10.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F3AFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInfo04);
export default __webpack_public_path__ + "static/media/subscription_info04.55f0ee3f01f355d92f42900d03ccf13d.svg";
export { ForwardRef as ReactComponent };